import React from "react";
import { Result } from "antd";

const NoDataPage = ({ title, subtitle = "", image }) => {
  return (
    <Result
      icon={
        <img src={image} alt="No Data" style={{ width: 80, height: 80 }} />
      }
      title={<span style={{ fontSize: 16, fontWeight: 500 }}>{title}</span>}
      subTitle={subtitle}
    />
  );
};

export default NoDataPage;
